import React, {useEffect, useRef} from 'react';
import {Input, Button} from 'antd-mobile';
import {useTranslation} from 'react-i18next';
import SearchIcon from '@/components/svgs/basic/search';

export interface SearchInputProps {
  className?: string;
  inputClassName?: string;
  placeholder?: string;
  onFocusBlur?: (focus: boolean) => void;
  onChange?: (value: string) => void;
  onSearch?: () => void;
  onAutoSearch?: () => void;
  onClear?: () => void;
  value: string;
  hasSearchButton?: boolean;
  disableSearch?: boolean;
  isSearching?: boolean;
}

const SearchInput: React.FC<SearchInputProps> = ({
  onFocusBlur,
  className,
  onChange,
  onSearch,
  onAutoSearch,
  onClear,
  disableSearch = false,
  hasSearchButton,
  value,
  placeholder,
  inputClassName,
  isSearching = false,
}) => {
  const {t} = useTranslation();
  const lastClickTimeRef = useRef(0);

  // 防抖逻辑
  useEffect(() => {
    const timer = setTimeout(() => {
      if (value.length === 0 || value.length >= 3) {
        onAutoSearch?.();
      }
    }, 1000);
    return () => clearTimeout(timer);
  }, [value, onAutoSearch]);

  // 搜索按钮点击处理（3秒节流）
  const handleSearchClick = () => {
    const now = Date.now();
    if (isSearching || now - lastClickTimeRef.current < 3000) {
      return;
    }
    lastClickTimeRef.current = now;
    onSearch?.();
  };

  return (
    <div className={`flex flex-row w-full gap-2 ${className || ''}`}>
      <div className="relative flex-1">
        <span className="absolute left-2 top-1/2 -translate-y-1/2 text-gray-500">
          <SearchIcon width={16} height={16} />
        </span>
        <Input
          className={`border border-[#D8E0EA] bg-white rounded h-10 pl-7 pr-2 w-full ${
            inputClassName || ''
          }`}
          placeholder={placeholder}
          value={value}
          onChange={val => {
            if (!/^[0-9]*$/g.test(val) && val !== '') {
              onChange?.(value);
              return;
            }
            if (val === '') {
              onChange?.('');
              return;
            }
            onChange?.(val);
          }}
          onFocus={() => onFocusBlur?.(true)}
          onBlur={() => onFocusBlur?.(false)}
          onKeyDown={e => {
            if (e.key === 'Enter') {
              onSearch?.();
            }
          }}
          onClear={onClear}
        />
      </div>
      {hasSearchButton && (
        <Button
          onClick={handleSearchClick}
          disabled={disableSearch}
          className={`gap-0 min-w-0 px-2 h-10 flex items-center justify-center bg-c1 text-white rounded text-sm ${
            disableSearch ? 'opacity-30' : ''
          }`}>
          {t('agent.searchText')}
        </Button>
      )}
    </div>
  );
};

export default SearchInput;
